import React from 'react';
import { Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2/Grid2';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TipComponent = ({ tip }) => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const isMediumScreen = useMediaQuery('(min-width:601px) and (max-width:960px)');
  const isLargeScreen = useMediaQuery('(min-width:961px)');

  let truncatedDescription;
  if (isSmallScreen) {
    truncatedDescription = tip.descripcion.substring(0, 80);
  } else if (isMediumScreen) {
    truncatedDescription = tip.descripcion.substring(0, 200);
  } else if (isLargeScreen) {
    truncatedDescription = tip.descripcion.substring(0, 500);
  }

  return (
    <Grid2 key={tip.id} className="tips-card">
        <img src={tip.imagen} alt={tip.titulo} className="tips-image" />
        <Grid2 className="tips-content">
            <Grid2 className="tips-description">
                <Typography className="tips-title">{tip.titulo}</Typography>
                <Typography className="tips-text">{truncatedDescription}</Typography>
            </Grid2>
            {/* Botón "Ver Tip" */}
            <Grid2>
                <Grid2 className="tips-button-container">
                    <button className="ver-tip-button" onClick={() => navigate(`/tip/${tip.id}`)}>Ver Tip</button>
                </Grid2>
                <Grid2 className="tips-footer">
                    <span className="tips-views">{tip.numeroLikes}</span>
                    <span className="material-icons tips-button">{"favorite_border"}</span>
                </Grid2>
            </Grid2>
        </Grid2>
    </Grid2>
  );
};

export default TipComponent;